var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", { staticClass: "w-full" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("tr", [
      _c("td", { staticClass: "text-left px-4 py-4 align-top" }, [
        _vm._v("\n            " + _vm._s(_vm.name) + "\n        "),
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "text-center px-4 py-4 align-top" }, [
        _vm._v("\n            " + _vm._s(_vm.period) + "\n        "),
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "text-right px-4 py-4 align-top" }, [
        _vm._v("£" + _vm._s(_vm.price)),
      ]),
    ]),
    _vm._v(" "),
    _vm.adminFee > 0
      ? _c("tr", [
          _c(
            "td",
            {
              staticClass:
                "text-right px-4 py-4 align-top border-t border-gray-200",
              attrs: { colspan: "2" },
            },
            [_vm._v("\n            Membership Administration Charge\n        ")]
          ),
          _vm._v(" "),
          _c(
            "td",
            {
              staticClass:
                "text-right px-4 py-4 align-top border-t border-gray-200",
            },
            [_vm._v("£" + _vm._s(_vm.adminFee))]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    parseFloat(_vm.customerCredit) > 0
      ? _c("tr", [
          _c(
            "td",
            {
              staticClass:
                "text-right px-4 py-4 align-top border-t border-gray-200",
              attrs: { colspan: "2" },
            },
            [_vm._v("\n            Account Credit\n        ")]
          ),
          _vm._v(" "),
          _c(
            "td",
            {
              staticClass:
                "text-right px-4 py-4 align-top border-t border-gray-200",
            },
            [
              _vm._v(
                "-£" +
                  _vm._s(
                    _vm.appliedCredit.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  )
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("tr", [
      _c(
        "td",
        {
          staticClass:
            "text-right px-4 py-4 align-top border-t border-gray-200 font-semibold",
          attrs: { colspan: "2" },
        },
        [_vm._v("\n            Total\n        ")]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass:
            "text-right px-4 py-4 align-top border-t border-gray-200",
        },
        [_vm._v("£" + _vm._s(_vm.total))]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { staticClass: "font-josefin uppercase text-left px-4 pb-4" }, [
        _vm._v("Membership Type"),
      ]),
      _vm._v(" "),
      _c(
        "th",
        { staticClass: "font-josefin uppercase text-center px-4 pb-4" },
        [_vm._v("Months")]
      ),
      _vm._v(" "),
      _c("th", { staticClass: "font-josefin uppercase text-right px-4 pb-4" }, [
        _vm._v("Price"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }